import { TBookSettings } from '../../../common/rest/endlessBook/endlessBookRest';
import {
	BOOKS_BUMP_RELOAD,
	BOOKS_SET_CREATING,
	BOOKS_SET_HOST,
	BOOKS_SET_REGENERATING,
	BOOKS_SET_SETTINGS,
	IBumpBookReloadAction,
	ISetBookCreatingAction,
	ISetBookHostAction,
	ISetBookRegeneratingAction,
	ISetBookSettingsAction,
} from './types';

export const setBookCreatingAction = (audioId: number, creating: boolean): ISetBookCreatingAction => ({
	type: BOOKS_SET_CREATING,
	audioId,
	creating,
});

export const setBookRegeneratingAction = (bookId: number, regenerating: boolean): ISetBookRegeneratingAction => ({
	type: BOOKS_SET_REGENERATING,
	bookId,
	regenerating,
});

export const bumpBookReloadAction = (bookId: number): IBumpBookReloadAction => ({
	type: BOOKS_BUMP_RELOAD,
	bookId,
});

export const setBookSettingsAction = (bookId: number, settings: TBookSettings): ISetBookSettingsAction => ({
	type: BOOKS_SET_SETTINGS,
	bookId,
	settings,
});

export const setBookHostAction = (bookHost: string | null, failed = false): ISetBookHostAction => ({
	type: BOOKS_SET_HOST,
	bookHost,
	failed,
});
